import { gql } from "@apollo/client";

export const setPasswordState = {
  newPassword1: "",
  newPassword2: "",
  newPassword1Status: "unchecked",
  newPassword2Status: "unchecked",
};

export const setPasswordStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "newPassword1": {
      const alphaNLenghthRegex = new RegExp("^.{8,15}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          newPassword1: value,
          newPassword1Status: "success",
        };
      } else if (!value) {
        return {
          ...state,
          newPassword1: "",
          newPassword1Status: "unchecked",
        };
      } else {
        return {
          ...state,
          newPassword1: value,
          newPassword1Status: "error",
        };
      }
    }
    case "newPassword2": {
      if (state?.newPassword1 == value && state?.newPassword1 != "") {
        return {
          ...state,
          newPassword2: value,
          newPassword2Status: "success",
        };
      } else if (!value) {
        return {
          ...state,
          newPassword2: "",
          newPassword2Status: "unchecked",
        };
      } else {
        return {
          ...state,
          newPassword2: value,
          newPassword2Status: "error",
        };
      }
    }

    default:
      return state;
  }
};
export const setPassword = gql`
  mutation setpassword($input: PasswordInput!) {
    setPassword(input: $input) {
      success
      message
      error
    }
  }
`;
